import { canEditIdea, hasPermission } from "./permissions"

export const shouldShowIdeaSection = (idea, section) => {
  if (!idea || !section) return false
  return section.type === "assessment"
    ? idea.ownerIdeaTemplate.assessmentEnabled && idea.isAssessor
    : section.fields?.length > 0 || section.type === "businessProfile" || section.type === "impact"
}

export const shouldShowIdeaEdiSection = (user, idea, section) => {
  if (!idea || !section) return false
  if (canEditIdea(user, idea)) return true
  if (section.type === "edi" && hasPermission(user, "org.viewEdi", idea.ownerChallenge?.organisation)) return true
  return false
}
